import React from 'react'
import List from '@material-ui/core/List'
import { useTheme } from '@material-ui/core'
import sortBy from 'lodash/sortBy'
import get from 'lodash/get'
import kebabCase from 'lodash/kebabCase'

import DrawerItem from 'guideParts/item/DrawerItem'

export default ({ content, pageSlug, hash, onLinkClick }) => {
  const theme = useTheme()
  const sortedContent = sortBy(content, 'sorting')

  return (
    <List
      component="div"
      style={{
        padding: theme.spacing(1, 5, 1, 0),
        position: 'sticky',
        top: 100,
      }}
    >
      {sortedContent.map((item, index) => {
        const title = get(item, 'title')
        const slug = `#${kebabCase(title)}`
        const isFirst = index === 0
        const isFirstWithoutHash = isFirst && !hash
        const isSelected = hash === slug

        return title ? (
          <DrawerItem
            key={title}
            withIcon={false}
            label={title}
            to={`/${pageSlug + slug}`}
            selected={isSelected || isFirstWithoutHash}
            onLinkClick={onLinkClick}
          />
        ) : null
      })}
    </List>
  )
}
